import { countries, TCountryCode } from 'countries-list';

const uniqueCurrencies = new Set<string>();

const countriesWithCurrencies = new Set<{
  countryName: string;
  currency: string;
}>();

Object.keys(countries).forEach((country) => {
  const countryCode = country as TCountryCode;
  const currency = countries[countryCode].currency[0];
  if (currency !== undefined && currency !== 'ALL') {
    uniqueCurrencies.add(currency);
    countriesWithCurrencies.add({
      countryName: country,
      currency: currency,
    });
  }
});
export const currencies = Array.from(uniqueCurrencies).map((currency) => ({
  label: currency,
  value: currency,
}));

export const getCurrencyByCountry = (country: string) => {
  return Array.from(countriesWithCurrencies).find(
    (currency) => currency.countryName === country,
  );
};
